// Notification history utilities - stores recent notifications in localStorage

export interface StoredNotification {
  id: string;
  title: string;
  body: string;
  source: 'wiseguy' | 'squeezo' | 'wsj_feed';
  timestamp: string; // ISO string
}

const STORAGE_KEY = 'notification_history';
const MAX_NOTIFICATIONS = 100;

export function getNotificationHistory(): StoredNotification[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    return JSON.parse(stored) as StoredNotification[];
  } catch {
    return [];
  }
}

export function addNotification(notification: Omit<StoredNotification, 'id' | 'timestamp'>): void {
  try {
    const history = getNotificationHistory();
    const newNotification: StoredNotification = {
      ...notification,
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toISOString(),
    };

    // Add to beginning (most recent first)
    history.unshift(newNotification);

    // Trim to max size
    if (history.length > MAX_NOTIFICATIONS) {
      history.splice(MAX_NOTIFICATIONS);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch {
    // Silently fail if localStorage is unavailable
  }
}

export function clearNotificationHistory(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Silently fail
  }
}
